// extracted by mini-css-extract-plugin
module.exports = {"contentBlock":"ContentBlock_contentBlock__GA1ep","contentBlock__gradient":"ContentBlock_contentBlock__gradient__14-XP"};